export enum ColorPickerColors {
  RED = 'red',
  PINK = 'pink',
  PURPLE = 'purple',
  DEEP_PURPLE = 'deepPurple',
  INDIGO = 'indigo',
  BLUE = 'blue',
  LIGHT_BLUE = 'lightBlue',
  CYAN = 'cyan',
  TEAL = 'teal',
  GREEN = 'green',
  LIGHT_GREEN = 'lightGreen',
  LIME = 'lime',
  YELLOW = 'yellow',
  AMBER = 'amber',
  ORANGE = 'orange',
  DEFAULT = 'transparent',
  DEFAULT_TEXT = 'defaultText',
  BLACK = 'black',
  WHITE = 'white',
  SILVER = 'silver',
  GRAY = 'gray',
}

export const ColorPickerColorsMap: Record<ColorPickerColors, string> = {
  [ColorPickerColors.RED]: '#f44336',
  [ColorPickerColors.PINK]: '#e91e63',
  [ColorPickerColors.PURPLE]: '#9c27b0',
  [ColorPickerColors.DEEP_PURPLE]: '#673ab7',
  [ColorPickerColors.INDIGO]: '#3f51b5',
  [ColorPickerColors.BLUE]: '#2196f3',
  [ColorPickerColors.LIGHT_BLUE]: '#03a9f4',
  [ColorPickerColors.CYAN]: '#00bcd4',
  [ColorPickerColors.TEAL]: '#009688',
  [ColorPickerColors.GREEN]: '#4caf50',
  [ColorPickerColors.LIGHT_GREEN]: '#8bc34a',
  [ColorPickerColors.LIME]: '#cddc39',
  [ColorPickerColors.YELLOW]: '#ffeb3b',
  [ColorPickerColors.AMBER]: '#ffc107',
  [ColorPickerColors.ORANGE]: '#ff9800',
  [ColorPickerColors.DEFAULT]: 'transparent',
  [ColorPickerColors.DEFAULT_TEXT]: '#000000',
  [ColorPickerColors.BLACK]: '#000000',
  [ColorPickerColors.WHITE]: '#ffffff',
  [ColorPickerColors.SILVER]: '#c0c0c0',
  [ColorPickerColors.GRAY]: '#808080',
};
